let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6FuHS"), load("eyaRC"), load("FBIp4")]).then(() => parcelRequire('cHhL0'));